import React, { useEffect, useState } from "react";
import axios from "../../../../axios";
import { useLocation, useParams } from "react-router-dom";
import { IP } from "../../../../internalServer";
import "./QueryMemberlist.css";

function GroupMemberList({ totalMember }) {
  const [group, setGroup] = useState();
  const { state } = useLocation();
  const [isGettingData, setIsGettingData] = useState(false);

  useEffect(() => {
    let getGroup = async () => {
      try {
        setIsGettingData(true);
        let response = await axios.get(
          `/api/v1/group/getById/${state.groupId}?isFullFledged=true`
        );
        setIsGettingData(false);
        response && setGroup(response.data.data);
      } catch (error) {
        console.log(error);
      }
    };
    getGroup();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className=" mt-2 p-0 student_list_box" style={{ width: "400px" }}>
        <div
          className=" student_list_header_colour"
          style={{
            width: "400px",
            height: "15px",
            background: "#f9960b",
            borderRadius: "10px 10px 0 0",
          }}
        ></div>
        <div className="px-2 mt-2 d-flex align-items-center justify-content-between student_list_header_box">
          <span>In this Query</span>
          {/* <img src="/images/cross.svg" alt="" style={{ cursor: "pointer" }} /> */}
        </div>
        <>
          {group ? (
            <div>
              <div className="mx-2 mt-1 completed_student_count">
                Total {totalMember} members
              </div>
              <div
                className="p-2 mt-1 completed_name_list_box orange-scrollBar "
                style={{ height: "120px", overflowY: "scroll" }}
              >
                <div className="mb-2 gap-2 d-flex flex-column">
                  {group?.member?.length > 0 &&
                    group?.member?.map((obj, index) => (
                      <div className="d-flex align-items-center">
                        {obj?.member_type === "Teacher" ? (
                          <img
                            src={
                              obj?.member?.profile_picture
                                ? IP +
                                  obj?.member?.profile_picture?.replace(
                                    /^\./,
                                    ""
                                  )
                                : obj?.member?.gender === "M"
                                ? "/images/Teacher_Male.jpg"
                                : obj?.member?.gender === "F"
                                ? "/images/Teacher_Female.png"
                                : "/images/default image.png"
                            }
                            alt={obj?.member?.name || ""}
                            className=""
                            style={{
                              width: "20px",
                              height: "20px",
                              borderRadius: "50%",
                              cursor: "pointer",
                              marginRight: "10px",
                            }}
                            key={obj?.member?.avatarProfile}
                            onError={(e) => {
                              if (obj?.member?.gender === "M") {
                                e.target.src = "/images/Teacher_Male.jpg";
                              } else if (obj?.member?.gender === "F") {
                                e.target.src = "/images/Teacher_Female.png";
                              } else {
                                e.target.src = "/images/default image.png";
                              }
                            }}
                          />
                        ) : (
                          <img
                            src={
                              obj?.member?.profile_picture
                                ? IP +
                                  obj?.member?.profile_picture.replace(
                                    /^\./,
                                    ""
                                  )
                                : obj?.member.gender === "M"
                                ? obj?.member?.avatarProfile
                                  ? "/images/Boys/" +
                                    obj?.member?.avatarProfile +
                                    ".webp"
                                  : "/images/Student_boy_pic.png"
                                : obj?.member?.gender === "F"
                                ? obj?.member?.avatarProfile
                                  ? "/images/Girls/" +
                                    obj?.member?.avatarProfile +
                                    ".webp"
                                  : "/images/Student_girl_pic.png"
                                : "/images/default image.png"
                            }
                            alt="icon"
                            className=""
                            style={{
                              width: "20px",
                              height: "20px",
                              borderRadius: "50%",
                              cursor: "pointer",
                              marginRight: "10px",
                            }}
                            key={obj?.member?.avatarProfile}
                            onError={(e) => {
                              e.target.src = obj?.member?.avatarProfile
                                ? "/images/Girls/" +
                                  obj?.member?.avatarProfile +
                                  ".webp"
                                : "/images/Student_girl_pic.png";
                              if (obj?.member?.gender === "M") {
                                e.target.src = obj?.member?.avatarProfile
                                  ? "/images/Boys/" +
                                    obj?.member?.avatarProfile +
                                    ".webp"
                                  : "/images/Student_boy_pic.png";
                              } else if (obj?.member?.gender === "F") {
                                e.target.src = obj?.member?.avatarProfile
                                  ? "/images/Girls/" +
                                    obj?.member?.avatarProfile +
                                    ".webp"
                                  : "/images/Student_girl_pic.png";
                              } else {
                                e.target.src = "/images/default image.png";
                              }
                            }}
                          />
                        )}
                        <span key={index} className=" completed_s_name_list">
                          {obj.member_type === "Teacher" && (
                            <>
                              {" " + obj?.member?.name || ""} | {"Teacher"} |{" "}
                              {"Code: " + obj?.member?.code || ""}
                            </>
                          )}
                          {obj.member_type === "Student" && (
                            <>
                              {" " + obj?.member?.name || ""} |{" "}
                              {obj?.member?.standard || ""} |{" "}
                              {obj?.member?.section || ""} |{" "}
                              {"Code: " + obj?.member?.code || ""}
                            </>
                          )}
                        </span>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          ) : isGettingData ? (
            <img
              className="ongoing_loader"
              style={{ width: "120px", height: "120px", marginLeft: "150px" }}
              src="/gif/LoaderDot.gif"
              alt=""
            />
          ) : (
            <div style={{ padding: "10px", fontSize: "13px" }}>
              No Record Found!
            </div>
          )}
        </>
      </div>
    </>
  );
}

export default GroupMemberList;
